(function () {
  'use strict';

  // A product card shows one swatch per colour. Clicking one already swaps the image; this
  // keeps the price and the Sale badge on the same variant, so a product with one discounted
  // colour stops advertising that price on the colours that are still full price.

  function vatIsEx() {
    try {
      return document.documentElement.getAttribute('data-vat-mode') === 'ex';
    } catch (e) {
      return false;
    }
  }

  function writePrice(node, incl, ex, inclStr, exStr) {
    if (!node) return;
    if (incl) node.setAttribute('data-price-incl', incl);
    if (ex) node.setAttribute('data-price-ex', ex);
    if (inclStr) node.setAttribute('data-price-incl-str', inclStr);
    if (exStr) node.setAttribute('data-price-ex-str', exStr);
    var str = vatIsEx() ? exStr : inclStr;
    if (str) node.textContent = str;
  }

  window.sgApplyCardVariantPrice = function (card, swatch) {
    if (!card || !swatch) return;
    if (!swatch.hasAttribute('data-variant-price-incl')) return;

    var priceEl = card.querySelector('[data-card-live-price]');
    var compareEl = card.querySelector('[data-card-compare-at]');
    var badgeEl = card.querySelector('[data-card-sale-badge]');
    var onSale = swatch.getAttribute('data-variant-on-sale') === 'true';

    writePrice(
      priceEl,
      swatch.getAttribute('data-variant-price-incl'),
      swatch.getAttribute('data-variant-price-ex'),
      swatch.getAttribute('data-variant-price-incl-str'),
      swatch.getAttribute('data-variant-price-ex-str')
    );

    if (compareEl) {
      if (onSale) {
        writePrice(
          compareEl,
          swatch.getAttribute('data-variant-compare-incl'),
          swatch.getAttribute('data-variant-compare-ex'),
          swatch.getAttribute('data-variant-compare-incl-str'),
          swatch.getAttribute('data-variant-compare-ex-str')
        );
      }
      compareEl.classList.toggle('display-none', !onSale);
    }

    if (badgeEl) badgeEl.classList.toggle('display-none', !onSale);
  };
})();
